export const authRoutes = [
  {
    path: '/login/utrakk',
    name: 'UtrakkIdpLogin',
    component: () => import('@/modules/auth/containers/utrakk-idp-login.container.vue'),
    meta: {
      requiresAuth: false,
      layout: 'newAuth',
    },
  },
  {
    path: '/login',
    name: 'AuthLogin',
    component: () => import('@/modules/auth/containers/new-login.container.vue'),
    meta: {
      requiresAuth: false,
      module: 'auth',
      layout: 'newAuth',
    },
  },
  // {
  //   path: '/login/company',
  //   name: 'CompanyLogin',
  //   component: () => import('@/modules/auth/containers/login.container.vue'),
  //   meta: {
  //     requiresAuth: false,
  //     layout: 'auth',
  //   },
  //   props: true,
  // },
  {
    path: '/login-processing',
    name: 'AuthLoginProcessing',
    component: () => import('@/modules/auth/containers/login-processing.container.vue'),
    meta: {
      requiresAuth: false,
      module: 'auth',
      layout: 'newAuth',
    },
  },
  {
    path: '/select-company',
    name: 'AuthSelectCompany',
    component: () => import('@/modules/auth/containers/select-company.container.vue'),
    meta: {
      requiresAuth: true,
      module: 'auth',
      layout: 'newAuth',
    },
  },
  {
    path: '/forgot-code',
    name: 'ForgotCode',
    component: () => import('@/modules/auth/containers/forgot-code.container.vue'),
    meta: {
      requiresAuth: false,
      module: 'auth',
      layout: 'auth',
    },
  },
  {
    path: '/account-chooser',
    name: 'AccountChooser',
    component: () => import('@/modules/auth/containers/account-chooser.container.vue'),
    meta: {
      requiresAuth: false,
      module: 'auth',
      layout: 'auth',
    },
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: () => import('@/core/components/dss-errors/dss-unauthorized.vue'),
    meta: {
      requiresAuth: false,
      module: 'auth',
      layout: 'error',
    },
  },
]

export default authRoutes
